import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Result, Button, Empty, List, Toast } from "antd-mobile";
import { ExclamationCircleOutline, CheckCircleOutline } from 'antd-mobile-icons';
import api from "../../../api";
import "./style.less";

const CardStatus = {
  '1': '正常使用',
  '2': '已被禁用',
  '3': '已被挂失',
}

const CardList = () => {
  const navigate = useNavigate()

  const [cardList, setCardList] = useState([])
  const [error, setError] = useState('')

  const refreshCardList = async () => {
    const resp = await api.userCardList()

    if (resp?.data?.code === 0) {
      setCardList(resp.data.data)
    } else {
      setError('获取IC卡列表出错，请稍后再试')
    }
  }

  const handleCardBindClick = () => {
    navigate('/card/bind')
  }

  const handleCardListClick = (card) => {
    if (card.status !== 1) {
      Toast.show({ content: 'IC卡' + CardStatus[card.status] + ', 不可操作', position: 'top' })
      return
    }

    navigate('/wallet/' + card.wallet.id)
  }

  useEffect(() => {
    refreshCardList()
  }, [])

  return (
    <div className="card-list-wrapper">
      {
        error ?
          <Result status='warning' title={error} />
          :
          <div className="card-list">
            {
              cardList.length === 0 ?
                <Empty description="你还一张卡没有欸，快去绑卡吧" />
                :
                <List mode='card'>
                  {
                    cardList.map((item, index) => (
                      <List.Item
                        key={index}
                        prefix={
                          item.status === 1 ? <CheckCircleOutline /> : <ExclamationCircleOutline />
                        }
                        extra={'¥ ' + item.wallet?.balance / 100}
                        description={'绑定时间: ' + item.createdDate}
                        onClick={() => handleCardListClick(item)}
                      // disabled={item.status === 3 ? true : false}
                      >
                        {item.cardNo}
                      </List.Item>
                    ))
                  }
                </List>
            }
          </div>
      }

      <div className="card-charge-button">
        <Button block color="success" size='large' onClick={handleCardBindClick}>绑 卡</Button>
      </div>
    </div>
  )
}

export default CardList